import $ from 'jquery';
import { setNewsList } from '../../scripts/news';
import { map__singlepoi, map__portal } from "../../scripts/map";

export default (client) => {
    
    
    if(getPageUrl().contentid === "nyheter"){
     
        setNewsList();
        
    }
    else if(getPageUrl().contentid == "enheter") {
        
     
        $("#maincontent").html(`
            <div class="container">
                <div class="row">
                    <div class="col">
                        <div class="map__singlepoi"></div>
                        <div class="map__portal"></div>
                    </div>
                </div>
            </div>
        `);

        // map__singlepoi(".map__singlepoi",{
        //     lat : 59.126930, 
        //     lon: 10.210610,
        //     popuptext : "mormor",
        //     popupopen : true
        // });
        
        map__portal(".map__portal");
        
        
    }
    
}